import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../services/FetchNodeServices";

const AllAbout = () => {
    const [about, setAbout] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchAbout();
    }, []);

    const fetchAbout = async () => {
        setIsLoading(true);
        try {
            const res = await axiosInstance.get("/api/v1/about/get-about");
            if (res.status === 200) {
                setAbout(res.data);
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                setAbout(null); // no record yet
            } else {
                toast.error("Error fetching About Us");
                console.error(error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This will delete the About Us content.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (confirm.isConfirmed) {
            try {
                const res = await axiosInstance.delete("/api/v1/about/delete-about");
                if (res.status === 200) {
                    setAbout(null);
                    Swal.fire("Deleted!", "About Us has been deleted.", "success");
                }
            } catch (error) {
                Swal.fire("Error!", "Unable to delete About Us.", "error");
                console.error(error);
            }
        }
    };

    if (isLoading) return <p>Loading About Us...</p>;

    return (
        <>
            <ToastContainer />

            <div className="bread">
                <div className="head">
                    <h4>About Us</h4>
                </div>
                <div className="links d-flex align-items-center gap-3">
                    {!about ? (
                        // No record yet — show Add button
                        <Link to="/add-about" className="add-new"  style={{borderRadius:5}} >
                            Add About Us <i className="fa-solid fa-plus"></i>
                        </Link>
                    ) : (
                        // Record exists — show Edit + Delete
                        <>
                            <Link to="/edit-about" className="bt edit"  style={{borderRadius:5}}>
                                Edit <i className="fa-solid fa-pen-to-square"></i>
                            </Link>
                            <button className="bt delete" style={{padding:5,borderRadius:5}}  onClick={handleDelete}>
                                Delete <i className="fa-solid fa-trash"></i>
                            </button>
                        </>
                    )}
                </div>
            </div>

            <section className="main-table mt-3">
                {!about ? (
                    <div className="text-center py-10 text-gray-500">
                        <i className="fa-solid fa-circle-info fa-2x mb-3"></i>
                        <p>No About Us content found. Click "Add About Us" to create one.</p>
                    </div>
                ) : (
                    <div className="p-4 bg-white border rounded">
                        <h5 className="fw-bold mb-4">{about.title}</h5>

                        {/* Render paragraphs exactly like the image */}
                        <div style={{ lineHeight: "1.8", color: "#333" }}>
                            {about.paragraphs.map((para, index) => (
                                <p key={index} className="mb-3" style={{ textAlign: "justify" }}>
                                    {para}
                                </p>
                            ))}
                        </div>

                        <hr className="my-3" />
                        <small className="text-muted">
                            Last updated: {new Date(about.updatedAt).toLocaleDateString()}
                        </small>
                    </div>
                )}
            </section>
        </>
    );
};

export default AllAbout;